module.exports = __webpack_public_path__ + "static/media/parallelogram_angle0.1db7a045.svg";